import { Button } from '#/components/ui/button';
import { Loader2 } from 'lucide-react';
import { ButtonProps, DialogFlag } from './helpers';

interface Props extends ButtonProps {
  flag: DialogFlag;
  loading?: boolean;
}

export function ActionButton({
  flag,
  loading,
  disabled,
  children,
  ...props
}: Props) {
  return (
    <Button {...props} disabled={loading || disabled}>
      {loading && <Loader2 className="animate-spin" />}
      {children}
    </Button>
  );
}
